export type ColorMode = 'light' | 'dark';
const COLOR_MODE_KEY = 'panel-color-mode';

export function readColorMode(): ColorMode {
    try { return localStorage.getItem(COLOR_MODE_KEY) === 'dark' ? 'dark' : 'light'; }
    catch { return 'light'; }
}

export function saveColorMode(mode: ColorMode): void {
    try { localStorage.setItem(COLOR_MODE_KEY, mode); }
    catch { /* Keep the toggle working when storage is unavailable. */ }
}

export function applyColorMode(mode: ColorMode): void {
    document.body.classList.remove('light-only', 'dark-sidebar');
    document.body.classList.toggle('dark-only', mode === 'dark');
    document.body.classList.toggle('light', mode === 'light');
}